import React, { useState } from 'react';
import { Container, Row, Col, Badge, Carousel, Modal, Button } from 'react-bootstrap';

const Products = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const products = [
    {
      id: 1,
      title: 'Aluminium Melting Furnace',
      category: 'Melting Systems',
      description: 'High-efficiency aluminium melting furnaces with tilting mechanism and ingot casting systems for optimal metal processing.',
      features: ['Tilting Position', 'Energy Efficient', 'Automated Control', 'Chain Caster'],
      folder: 'ALUMINIUM_MELTING',
      images: [
        'Al melting furnace.jpg',
        'Al melting furnace (4).jpg',
        'Al melting furnace (3).jpg',
        'Aluminium Melting Furnace in tilting position front.jpg',
        'Aluminium Ingot casting chain caster.JPG'
      ]
    },
    {
      id: 2,
      title: 'Copper & Lead Refining Plant',
      category: 'Refining Systems',
      description: 'Complete copper and lead refining solutions with pot furnaces, ingot casting systems and pollution control.',
      features: ['2000 MT/Month', 'Refining Pots', 'Ingot Casting', 'Crane System'],
      folder: 'COPPER_MELTING',
      images: [
        'three refining pot furnaces with total capacity of 2000 mt per month - Copy.jpg',
        'Refining pots, ingot casting system and crane.jpg',
        'Lead Refining pot furnae and stirrer.jpg',
        'Refined lead ingots ready to dispatch.jpg',
        'Dispatch of refining pots.jpg',
        'Air pollution control plant for Lead refining.jpg'
      ]
    },
    {
      id: 3,
      title: 'Air Pollution Control Systems',
      category: 'Environmental Solutions',
      description: 'Advanced air pollution control systems including bag houses, cyclones, and wet scrubbers for industrial applications.',
      features: ['Pulse Jet Cleaning', 'Bag House', 'Cyclone System', 'Wet Scrubber'],
      folder: 'air_pollution',
      images: [
        'Air pollution control plant dry system.jpg',
        'Pulse jet cleaning system of Bag house.jpg',
        'Filter bags fitting inside the bag house.jpg',
        'Cyclone and Baghouse connection.jpg',
        'WhatsApp Image 2024-08-09 at 17.07.16.jpeg',
        'WhatsApp Image 2024-08-09 at 17.07.15 (2).jpeg'
      ]
    },
    {
      id: 4,
      title: 'Heat Treatment Furnaces',
      category: 'Heat Treatment',
      description: 'Precision heat treatment furnaces for various industrial applications with controlled atmosphere systems.',
      features: ['Controlled Atmosphere', 'Uniform Heating', 'Energy Efficient', 'Digital Control'],
      folder: 'HEAT_TREATMENT',
      images: [
        'GCF RETROT.jpeg'
      ]
    },
    {
      id: 5,
      title: 'Lead Rotary Furnaces',
      category: 'Rotary Systems',
      description: 'Specialized lead rotary furnaces for efficient metal processing with advanced control systems.',
      features: ['Rotary Design', 'High Efficiency', 'Automated Control', 'Safety Systems'],
      folder: 'Lead_Rotary',
      images: [
        'DSC03313.JPG',
        'DSC03314.JPG'
      ]
    },
    {
      id: 6,
      title: 'Lead Refining Plant',
      category: 'Refining Systems',
      description: 'Complete lead refining plant solutions with advanced purification and casting systems.',
      features: ['Complete Plant', 'Purification', 'Casting System', 'Quality Control'],
      folder: 'LEAD_REFINING_PLANT',
      images: [
        'three refining pot furnaces with total capacity of 2000 mt per month - Copy.jpg',
        'Refining pots, ingot casting system and crane.jpg',
        'Lead Refining pot furnae and stirrer.jpg',
        'Refined lead ingots ready to dispatch.jpg',
        'Dispatch of refining pots.jpg',
        'Air pollution control plant for Lead refining.jpg'
      ]
    },
    {
      id: 7,
      title: 'Rotary Furnace Systems',
      category: 'Rotary Systems',
      description: 'Advanced rotary furnace systems for battery recycling and lead metal processing applications.',
      features: ['Battery Recycling', 'Lead Processing', 'Automated Systems', 'High Capacity'],
      folder: 'Rotary_Finance',
      images: [
        'Rotary furnace for Battery Recycling plant.JPG',
        'Rotary furnace for battery recycling.JPG',
        'Lead metal pouring from Rotary furnace (1).JPG',
        'Lead metal block.JPG',
        'Dispatch of Rotary furnace.jpg'
      ]
    }
  ];

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const ProductCard = ({ product }) => (
    <Col lg={6} xl={4} className="mb-4">
      <div className="product-card h-100" onClick={() => handleProductClick(product)} style={{ cursor: 'pointer' }}>
        <div className="product-image-container mb-3" style={{ height: '250px', overflow: 'hidden', borderRadius: '12px' }}>
          {product.images.length > 0 ? (
            <Carousel indicators={false} controls={product.images.length > 1} interval={3000}>
              {product.images.map((image, index) => (
                <Carousel.Item key={index}>
                  <img
                    src={`/images/${product.folder}/${image}`}
                    alt={`${product.title} ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '250px',
                      objectFit: 'cover',
                      borderRadius: '12px'
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <div style={{
              width: '100%',
              height: '250px',
              background: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '1.2rem',
              fontWeight: '600'
            }}>
              {product.title}
            </div>
          )}
        </div>
        
        <Badge bg="primary" className="mb-2">{product.category}</Badge>
        <h4>{product.title}</h4>
        <p>{product.description}</p>
        
        <div className="mt-3">
          {product.features.map((feature, idx) => (
            <Badge bg="secondary" className="me-2 mb-2" key={idx} style={{ fontSize: '0.75rem' }}>
              {feature}
            </Badge>
          ))}
        </div>
        
        <div className="mt-3">
          <Button variant="outline-primary" size="sm">
            View Details →
          </Button>
        </div>
      </div>
    </Col>
  );

  return (
    <>
      <div className="page-header">
        <Container>
          <h1>Our Products</h1>
          <p>Advanced thermal equipment and systems for industrial applications</p>
        </Container>
      </div>

      <section className="section-padding">
        <Container>
          <div className="section-title">
            <h2>Product Gallery</h2>
            <p>Explore our comprehensive range of thermal solutions</p>
          </div>
          <Row>
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </Row>
        </Container>
      </section>

      <section className="section-padding company-profile-section">
        <Container>
          <div className="section-title">
            <h2>Product Demo Videos</h2>
            <p>Watch our thermal solutions and manufacturing processes in action</p>
          </div>
          
          {/* Featured Video */}
          <Row className="justify-content-center mb-5">
            <Col lg={10}>
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/PW4KSKwV6B4?rel=0&modestbranding=1"
                    title="Allied Thermal Main Demo"
                    allowFullScreen
                    style={{
                      borderRadius: '12px',
                      border: 'none'
                    }}
                  ></iframe>
                </div>
                <div className="text-center mt-3">
                  <p className="mb-2" style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1e293b' }}>
                    🎥 Featured: Allied Thermal Manufacturing Excellence
                  </p>
                  <p className="text-muted">
                    Complete overview of our advanced thermal solutions and manufacturing capabilities
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Video Gallery Grid */}
          <Row>
            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/Sc1La25b4To?rel=0&modestbranding=1"
                    title="Allied Thermal Process 1"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🔥 Furnace Operations</h6>
                  <small className="text-muted">Industrial furnace systems in operation</small>
                </div>
              </div>
            </Col>
            
            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/DRv_UJVKLxc?rel=0&modestbranding=1"
                    title="Allied Thermal Process 2"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>⚙️ Manufacturing Process</h6>
                  <small className="text-muted">Advanced manufacturing techniques</small>
                </div>
              </div>
            </Col>
            
            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/Vjjt97jVr04?rel=0&modestbranding=1"
                    title="Allied Thermal Process 3"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🏭 Plant Operations</h6>
                  <small className="text-muted">Complete plant setup and operations</small>
                </div>
              </div>
            </Col>
            
            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/RFVDpmy_j4Y?rel=0&modestbranding=1"
                    title="Allied Thermal Process 4"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🔧 Quality Control</h6>
                  <small className="text-muted">Quality assurance and testing procedures</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/2I5vnbax8SU?rel=0&modestbranding=1"
                    title="Ingot Stacker Robot"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🤖 Ingot Stacker Robot</h6>
                  <small className="text-muted">Automated ingot stacking system</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/aSxxiVyj7eo?rel=0&modestbranding=1"
                    title="10 Ton Furnace Casting"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🔥 10 Ton Furnace Casting</h6>
                  <small className="text-muted">High capacity furnace casting process</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/rZ3-wD8JZwM?rel=0&modestbranding=1"
                    title="10 Ton Furnace Under Smoke Hood"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>💨 10 Ton Furnace Covered Under Huge Smoke Hood</h6>
                  <small className="text-muted">Furnace with advanced smoke control system</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/5k5-pIg-mxA?rel=0&modestbranding=1"
                    title="20 Ton Furnace"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🏭 20 Ton Furnace</h6>
                  <small className="text-muted">Heavy duty 20 ton capacity furnace</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/WujUhnV_Ork?rel=0&modestbranding=1"
                    title="Automatic Ingot Stacker"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>⚙️ Automatic Ingot Stacker</h6>
                  <small className="text-muted">Fully automated ingot stacking system</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/PRzky6-P60E?rel=0&modestbranding=1"
                    title="Dross Removal"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🧹 Dross Removal</h6>
                  <small className="text-muted">Efficient dross removal process</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/4a-aCydw-aU?rel=0&modestbranding=1"
                    title="Hydraulic Charger"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🔧 Hydraulic Charger</h6>
                  <small className="text-muted">Hydraulic charging system operation</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/yjTJkzt6M0g?rel=0&modestbranding=1"
                    title="Ingot Collection"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>📦 Ingot Collection</h6>
                  <small className="text-muted">Ingot collection and handling process</small>
                </div>
              </div>
            </Col>

            <Col lg={6} className="mb-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/zxpywvWUrlw?rel=0&modestbranding=1"
                    title="Ingot Casting"
                    allowFullScreen
                    style={{ borderRadius: '8px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-2">
                  <h6 style={{ color: '#1e293b', fontWeight: '600' }}>🔥 Ingot Casting</h6>
                  <small className="text-muted">Precision ingot casting process</small>
                </div>
              </div>
            </Col>
          </Row>
          
          <div className="text-center mt-4">
            <p style={{ fontSize: '1.1rem', color: '#64748b', fontStyle: 'italic' }}>
              📺 All videos showcase real Allied Thermal equipment and processes
            </p>
          </div>
        </Container>
      </section>

      <section className="section-padding">
        <Container>
          <div className="section-title">
            <h2>Product Categories</h2>
            <p>Comprehensive range of thermal solutions</p>
          </div>
          <Row>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">50+</span>
                <p>Product Models</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">15</span>
                <p>Years Warranty</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">ISO</span>
                <p>Certified Quality</p>
              </div>
            </Col>
            <Col lg={3} md={6} className="mb-4">
              <div className="stats-card">
                <span className="stats-number">24/7</span>
                <p>Technical Support</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Product Detail Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <>
              {selectedProduct.images.length > 0 && (
                <Carousel className="mb-4">
                  {selectedProduct.images.map((image, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={`/images/${selectedProduct.folder}/${image}`}
                        alt={`${selectedProduct.title} ${index + 1}`}
                        style={{
                          width: '100%',
                          height: '400px',
                          objectFit: 'cover',
                          borderRadius: '12px'
                        }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              )}
              
              <Badge bg="primary" className="mb-3">{selectedProduct.category}</Badge>
              <p className="mb-3">{selectedProduct.description}</p>
              
              <h6>Key Features:</h6>
              <div className="mb-3">
                {selectedProduct.features.map((feature, idx) => (
                  <Badge bg="secondary" className="me-2 mb-2" key={idx}>
                    ✓ {feature}
                  </Badge>
                ))}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" href="/contact-us">
            Get Quote
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Products;
